export default "__VITE_ASSET__Cs1GbOge__"